import { rangeDate, toISOString } from 'common/utils/date';
import { useRouter } from 'next/router';
import React from 'react';

export default function useDefaultValuesReportDate(prefix: string) {
  const date = rangeDate();
  const { query } = useRouter();
  const defaultFilters = React.useMemo(() => {
    const init = [
      {
        name: `${prefix}_at_after`,
        value: toISOString(date.atAfter),
      },
      {
        name: `${prefix}_at_before`,
        value: toISOString(date.atBefore),
      },
    ];

    const atAfter = query?.[`filter[${prefix}_at_after]`] as string | undefined;

    const atBefore = query?.[`filter[${prefix}_at_before]`] as
      | string
      | undefined;

    if (atAfter) {
      init[0].value = atAfter;
    }

    if (atBefore) {
      init[1].value = atBefore;
    }

    return init;
  }, [date.atAfter, date.atBefore, prefix, query]);

  return defaultFilters;
}
